import api from './api';

// Obtener todos los inventarios
export const getAllInventories = async (storeId) => {
  try {
    const params = storeId ? { storeId } : {};
    const response = await api.get('/inventories', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching inventories:', error);
    throw error;
  }
};

// Obtener un inventario por ID
export const getInventoryById = async (id) => {
  try {
    const response = await api.get(`/inventories/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching inventory:', error);
    throw error;
  }
};

// Obtener productos disponibles para inventario (filtrados por ProductsByStore)
export const getAvailableProducts = async (storeId) => {
  try {
    const response = await api.get('/inventories/available-products', {
      params: { storeId }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching available products:', error);
    throw error;
  }
};

// Crear nuevo inventario
export const createInventory = async (inventoryData) => {
  try {
    const response = await api.post('/inventories', inventoryData);
    return response.data;
  } catch (error) {
    console.error('Error creating inventory:', error);
    throw error;
  }
};

// Actualizar inventario
export const updateInventory = async (id, inventoryData) => {
  try {
    const response = await api.put(`/inventories/${id}`, inventoryData);
    return response.data;
  } catch (error) {
    console.error('Error updating inventory:', error);
    throw error;
  }
};

// Eliminar inventario
export const deleteInventory = async (id) => {
  try {
    const response = await api.delete(`/inventories/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting inventory:', error);
    throw error;
  }
};

// Bloquear/Desbloquear inventario
export const toggleLockInventory = async (id) => {
  try {
    const response = await api.patch(`/inventories/${id}/toggle-lock`);
    return response.data;
  } catch (error) {
    console.error('Error toggling inventory lock:', error);
    throw error;
  }
};

// Reordenar items del inventario
export const reorderInventoryItems = async (id, itemOrders) => {
  try {
    const response = await api.patch(`/inventories/${id}/reorder`, {
      itemOrders
    });
    return response.data;
  } catch (error) {
    console.error('Error reordering inventory items:', error);
    throw error;
  }
};

// Agregar pérdida a un inventario
export const addInventoryLoss = async (inventoryId, lossData) => {
  try {
    const response = await api.post(`/inventories/${inventoryId}/losses`, lossData);
    return response.data;
  } catch (error) {
    console.error('Error adding inventory loss:', error);
    throw error;
  }
};

// Eliminar pérdida de un inventario
export const deleteInventoryLoss = async (inventoryId, lossId) => {
  try {
    const response = await api.delete(`/inventories/${inventoryId}/losses/${lossId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting inventory loss:', error);
    throw error;
  }
};

// Obtener productos del último inventario de una ubicación
export const getLastInventoryProducts = async (locationId) => {
  try {
    const response = await api.get(`/inventories/last-products/${locationId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching last inventory products:', error);
    throw error;
  }
};

export const importInventoryFromExcel = async (file, storeId, onProgress) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('storeId', storeId);
  const response = await api.post('/inventories/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => { if (onProgress) onProgress(Math.round((e.loaded * 100) / e.total)); }
  });
  return response.data;
};

// Lista de inventarios de una location (para el selector de fecha)
export const getInventoriesByLocation = async (locationId) => {
  try {
    const response = await api.get(`/inventories/by-location/${locationId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching inventories by location:', error);
    throw error;
  }
};

// Productos de un inventario específico
// uncountedOnly = true → solo los que tienen quantity = 0
export const getInventoryProducts = async (inventoryId, uncountedOnly = false) => {
  try {
    const response = await api.get(`/inventories/${inventoryId}/products`, {
      params: { uncountedOnly }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching inventory products:', error);
    throw error;
  }
};